// File: packages/calculator/components/PlatformSelector.tsx

import React from 'react';
import clsx from 'clsx';
import { Clock } from 'lucide-react';
import { useCalculator } from '@dopomogai/agent-kit';

/**
 * A component that allows the user to select the integration platform,
 * which can affect feature compatibility and ETA.
 */
export function PlatformSelector() {
  const { spec, state, actions } = useCalculator();

  if (!spec.platforms || spec.platforms.length <= 1) {
    return null; // Don't render if there's no choice to be made
  }

  return (
    <section>
      <div className="mb-3 font-extrabold text-slate-900">1. Choose your platform</div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {spec.platforms.map((platform) => {
          const isActive = state.platformId === platform.id;
          return (
            <button
              key={platform.id}
              type="button"
              onClick={() => actions.setPlatform(platform.id)}
              aria-pressed={isActive}
              className={clsx(
                'text-left p-4 border-2 border-black rounded-xl bg-white transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-emerald-500',
                isActive
                  ? 'ring-2 ring-emerald-400 shadow-[2px_2px_0_0_#000]'
                  : 'hover:-translate-y-0.5 hover:shadow-[2px_2px_0_0_#000]'
              )}
            >
              <div className="font-bold text-slate-900">{platform.label}</div>

              {platform.notes && (
                <p className="mt-1 text-xs text-slate-600">{platform.notes}</p>
              )}

              {platform.etaDays[1] > 0 && (
                <div className="mt-2 text-xs font-semibold text-slate-700 flex items-center gap-1">
                  <Clock className="w-3.5 h-3.5" />
                  <span>+{platform.etaDays[0]}–{platform.etaDays[1]} days setup</span>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
}